import React, { useState } from 'react';
import './SeeMoreLessList.css';

export const SeeMoreLessList = ({
    items,
    maxItems
}) => {
    const [isOpen, setIsOpen] = useState(false);
    const toggle = () => setIsOpen(!isOpen);

    const getRenderedItems = () => {
        if (isOpen) {
            return items;
        }
        return items.slice(0, maxItems);
    }

    let button;
    if (items.length > maxItems) {
        button = (
            <button className='see-more-see-less' onClick={toggle}>
                {isOpen ? 'see less' : '... see more'}
            </button>
        );
    }

    return (
        <ul>
            {getRenderedItems().map((item, id) => (
                <li key={id}>{item}</li>
            ))}
            {button}
        </ul>
    );

};
